// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__ERvMs","checkboxCol":"Table_checkboxCol__JuUOr","emailCol":"Table_emailCol__d_zEr","actionCol":"Table_actionCol__O7xqL"};